import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MapPin, ExternalLink, Calendar, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { WEEKDAYS_IT } from "@/lib/api";

export default function StudioPreviewModal({ studio, open, onClose }) {
  const navigate = useNavigate();
  if (!studio) return null;

  const query = encodeURIComponent(studio.address || studio.name);
  const embedSrc = `https://www.google.com/maps?q=${query}&output=embed&hl=it&z=15`;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent data-testid="studio-preview-modal" className="max-w-2xl max-h-[92vh] overflow-y-auto bg-white p-0">
        <div className="p-6 border-b border-[#E0E5E2]">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-[#1A231F]">{studio.name}</DialogTitle>
            <div className="flex items-center gap-1.5 text-sm text-[#5C7066] mt-1">
              <MapPin size={14} className="text-[#2D4A3E]" />
              <span>{studio.address}</span>
            </div>
          </DialogHeader>
        </div>

        <div className="aspect-[16/10] w-full bg-[#F5F1E6]" data-testid="studio-preview-map">
          <iframe
            title={`Mappa ${studio.name}`}
            src={embedSrc}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="p-6">
          <div className="overline mb-3">Giorni di ricevimento</div>
          <div className="space-y-1.5">
            {studio.schedule?.map((sc, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-[#5C7066]">
                <Clock size={14} className="text-[#2D4A3E]" />
                <span><b className="text-[#1A231F]">{WEEKDAYS_IT[sc.weekday]}</b> · {sc.start} → ultimo appuntamento {sc.last_start}</span>
              </div>
            ))}
          </div>

          <div className="mt-6 grid sm:grid-cols-2 gap-3">
            <button
              data-testid="preview-book-here-btn"
              onClick={() => navigate(`/prenota?studio=${studio.id}`)}
              className="inline-flex items-center justify-center gap-2 h-14 rounded-xl bg-[#2D4A3E] text-white hover:bg-[#1A2F26] transition-colors font-medium"
            >
              <Calendar size={18} /> Prenota qui
            </button>
            <a
              data-testid="preview-open-maps-btn"
              href={studio.maps_url || `https://www.google.com/maps/search/?api=1&query=${query}`}
              target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 h-14 rounded-xl border border-[#2D4A3E] text-[#2D4A3E] hover:bg-[#2D4A3E] hover:text-white transition-colors font-medium"
            >
              <ExternalLink size={16} /> Apri in Google Maps
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
